import { Atom } from 'AppReact';
import styled, { css } from "styled-components";

const template = styled.div`
 ${({ theme, displayState }) => css`
    font-weight: ${displayState?.fontWeight ? displayState.fontWeight : 400};
    font-size: 12px;
    line-height: 14px;
    color: ${displayState?.color ?? theme?.colour?.secondary ?? '#04333B'};
  `}
`;

export default Atom({ type: 'label', dataType: 'string', template })